<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section">
    <div class="my-account-title">Login Information</div>
    <div class="account_login_info">
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label">Email Address</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p">{{AccountView.emailAddress}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label">Password</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
          <p class="account_p">{{AccountView.password}}</p>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17" v-on:click="EditSection()">Edit</button>
      </div>
    </div>

    <loading-component v-if="isLoading"></loading-component>
    <div v-if="isModalShown">
      <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
          <div class="modal-dialog modal-md">
            <div class="modal-content modal-edit-bg">
              <div class="modal-body">
                <div class="close_btn" v-on:click="CloseModal()"></div><br>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <edit-login-info 
                      @ValidateEmail="IsEmailAddressValid()"
                      @confirmEmail="ValidateMatchEmail()"
                      v-bind:LoginFormInputs="LoginFormInputs" 
                      :LoginValidationResult="LoginValidationResult" 
                      :LoginErrorMessage="LoginErrorMessage" 
                      :LoginEdit="LoginEdit"></edit-login-info>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                      <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="SaveLoginInformation()">Save</button>
                      <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-17" v-on:click="CloseModal()">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditLoginInfo from "@/components/portal/userAccount/accountEdit/EditLoginInfo";
import UserAccountVue from "../UserAccount.vue";
import LoadingComponent from "@/components/shared/LoadingComponent";
export default {
  props: [
    "AccountView",
    "LoginFormInputs",
    "LoginEdit"
  ],
  components: { EditLoginInfo, LoadingComponent },
  data() {
    return {
      isModalShown: false,
      LoginValidationResult: {},
      LoginErrorMessage: "",
      isLoading: false
    };
  },
  methods: {
    HidePassword() {
      // var passcount = this.AccountView.password.length;
      // var pass = '';
      // for(var i=0; i<passcount; i++){
      // pass+="*";
      // }
      // this.password = pass;
    },
    EditSection() {
      document.body.classList.add("body-overflow");
      this.LoginValidationResult = {};
      this.LoginErrorMessage = "";
      this.NewLoginEdit();
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
    },
    SaveLoginInformation() {
      var _this = this;
      _this.isLoading = true;
      _this.LoginValidationResult = {};
      _this.LoginErrorMessage = "";
      axios
        .post("/Account/LoginInformation", this.LoginEdit, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(function(response) {
           _this.isLoading = false;
          if (response.data.isSuccess == true) {
            localStorage.removeItem("host");
            localStorage.removeItem("token");
            localStorage.removeItem("watchword");
            localStorage.setItem("host", response.data.raw.username);
            localStorage.setItem("token", response.data.raw.token);
            localStorage.setItem("watchword", response.data.raw.password);
            _this.NewLoginEdit();
            _this.isModalShown = false;
            _this.$emit("selfReload");
            _this.CloseModal();
            _this.$emit("success");
          } else {
            if (response.data.errorMessage == "Invalid parameters") {
              _this.LoginValidationResult = response.data.raw.validationResult;
            } else {
              _this.LoginErrorMessage = response.data.errorMessage;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({name: 'Error'});
        });
    },
    NewLoginEdit() {
      this.LoginEdit.emailAddress = "";
      this.LoginEdit.emailAddressConfirm = "";
      this.LoginEdit.password = "";
      this.LoginEdit.newPassword = "";
      this.LoginEdit.newPasswordConfirm = "";
    },
    IsEmailAddressValid() {
    var _this = this;
    var emailAddress = _this.LoginEdit.emailAddress;
    if (emailAddress == null || emailAddress == '') {
     _this.LoginValidationResult = { AccountEmailAddress: null };
    }
    else {
       axios
        .get("/Account/IsEmailAddressValid/" + this.LoginEdit.emailAddress)
        .then(response => {
            _this.LoginValidationResult = {AccountEmailAddress: response.data.errorMessage};
        })
        .catch(error => {
        console.log(error);
        });
      }
    },
    ValidateConfirmEmail() {
      var _this = this;
      var confirmEmailAddress = _this.LoginEdit.emailAddressConfirm;
      if (confirmEmailAddress == null || confirmEmailAddress == '') {
        _this.LoginValidationResult = { AccountEmailAddressConfirm: null };
      }
      else {
        axios
          .get("/Account/IsEmailAddressValid/" + this.LoginEdit.emailAddressConfirm)
          .then(response => {
              _this.LoginValidationResult = {AccountEmailAddressConfirm: response.data.errorMessage};
          })
          .catch(error => {
          console.log(error);
          });
        }

    },
    ValidateMatchEmail() {
      var _this = this;
      if(_this.LoginEdit.emailAddress == null || _this.LoginEdit.emailAddress == ''){
        _this.ValidateConfirmEmail();
      }
      else {
         if (_this.LoginEdit.emailAddress != _this.LoginEdit.emailAddressConfirm) {
        _this.LoginValidationResult = {
          AccountEmailAddressConfirm: "Email address does not match"
        };
        } else {
          _this.LoginValidationResult = { AccountEmailAddressConfirm: null };
        }
      }
     
    }
  },
  created() {
    this.HidePassword();
  }
};
</script>



// WEBPACK FOOTER //
// LoginInfo.vue?6cae207f